<template>
  <div class="row">
    <div class="col-md-12" v-if="viewTelemetria">
      <div class="row">
        <div class="col-md-3 alturaTotal">
          <b-card>
            <b-card-body class="pb-0">
              <b-card-title>
                <h5 class="card-title">Telemetria do Veículo</h5>
              </b-card-title>

              <div id="map" style="height: 428px"></div>

              <div>
                <!-- INFORMAÇOES TRAJETO -->
                <div class="row" v-if="diaMapa">
                  <div class="div-clickable col-md-6 mt-4">
                    <div class="bg-info bg-soft text-center p-3">
                      <h5 class="font-size-14 mb-0">Data</h5>
                    </div>
                    <div class="text-center p-1 border">
                      <h4>{{ diaMapa }}</h4>
                    </div>
                  </div>
                  <div class="div-clickable col-md-6 mt-4">
                    <div class="bg-info bg-soft text-center p-3">
                      <h5 class="font-size-14 mb-0">Trajeto/dia (KM)</h5>
                    </div>
                    <div class="text-center p-1 border">
                      <h4>{{ (kmDiario / 1000).toFixed(1) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
        <div class="col-md-9">
          <b-card class="alturaTotal">
            <b-card-body class="pb-0">
              <b-card-title>
                <h5 class="card-title">Dados da Telemetria</h5>
              </b-card-title>
              <!-- TABELA DE OCORRENCIAS -->
              <div class="table-responsive col-md-12 font-size-12 m-auto">
                <b-table responsive="sm" :items="telemetriaDiaria" :fields="camposTelemetria" per-page="7"
                  :current-page="currentPageTelemetria" @row-clicked="montarMapaDirecoes" tbody-tr-class="div-clickable"
                  hover>
                  <template #head(excesso)="scope">
                    <div class="talkbubble-bottom" v-if="toolTipTable.ex">
                      Excesso de Velocidade<br />
                      Critérios:<br />
                      Entre 120 e 129 KM/H – De 00:00:00 a 23:59:59
                    </div>
                    <span class="badge badge-pill font-size-12 badge-soft-warning" @mouseover="toolTipTable.ex = true"
                      @mouseout="toolTipTable.ex = false">
                      {{ scope.label }}
                    </span>
                  </template>
                  <template #head(foraHorario)="scope">
                    <div class="talkbubble-bottom" v-if="toolTipTable.fh" style="top: 60%">
                      Fora do Horário<br />
                      Critérios:<br />
                      Domingo – De 00:00:00 a 23:59:59<br />
                      Segunda-Feira – Noturno – De 21:00:00 a 23:59:59<br />
                      Terça-Feira – Noturno – De 21:00:00 a 23:59:59<br />
                      Quarta-Feira – Noturno – De 21:00:00 a 23:59:59<br />
                      Quinta-Feira – Noturno – De 21:00:00 a 23:59:59<br />
                      Sexta-Feira – Noturno – De 21:00:00 a 23:59:59<br />
                      Sábado - Vespertino/Noturno– De 14:00:00 a 23:59:59<br />
                    </div>
                    <span class="badge badge-pill font-size-12 badge-soft-secondary" @mouseover="toolTipTable.fh = true"
                      @mouseout="toolTipTable.fh = false">
                      {{ scope.label }}
                    </span>
                  </template>
                  <template #head(madrugada)="scope">
                    <div class="talkbubble-bottom" v-if="toolTipTable.ma" style="top: 60%">
                      Uso na Madrugada<br />
                      Critérios:<br />
                      Segunda-Feira – Madrugada – De 00:00:00 a 04:59:59<br />
                      Terça-Feira – Madrugada – De 00:00:00 a 04:59:59<br />
                      Quarta-Feira – Madrugada – De 00:00:00 a 04:59:59<br />
                      Quinta-Feira – Madrugada – De 00:00:00 a 04:59:59<br />
                      Sexta-Feira – Madrugada – De 00:00:00 a 04:59:59<br />
                      Sábado – Madrugada – De 00:00:00 a 04:59:59<br />
                    </div>
                    <span class="badge badge-pill font-size-12 badge-soft-primary" @mouseover="toolTipTable.ma = true"
                      @mouseout="toolTipTable.ma = false">
                      {{ scope.label }}
                    </span>
                  </template>
                  <template #head(risco)="scope">
                    <div class="talkbubble-bottom" v-if="toolTipTable.ri" style="top: 60%">
                      Conducao de Risco<br />
                      Critérios:<br />
                      Acima de 130 KM/H – De 00:00:00 a 23:59:59
                    </div>
                    <span class="badge badge-pill font-size-12 badge-soft-danger" @mouseover="toolTipTable.ri = true"
                      @mouseout="toolTipTable.ri = false">
                      {{ scope.label }}
                    </span>
                  </template>
                  <template #head(informativo)="scope">
                    <span class="badge bg-light text-dark font-size-12" data-tooltip="Informativo"
                      data-tooltip-location="left">
                      {{ scope.label }}
                    </span>
                  </template>
                  <template #cell(data)="data">
                    {{ data.value }} -
                    {{ $tools.diaSemanaAbrev(data.item.dt_gps.getDay()) }}
                  </template>
                </b-table>
                <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPageTelemetria" :total-rows="rowsTelemetria"
                      per-page="7"></b-pagination>
                  </ul>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
    <div class="col-md-4" v-if="viewAprimora">
      <b-card>
        <b-card-title>
          <h5 class="card-title">Aprimora - Atividades Técnicas</h5>
        </b-card-title>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="syncTelemetria" v-model="syncTelemetria"
            :disabled="disabledSyncTelemetria" @change="sincronizaAprimoraTelemetria" />
          <label class="form-check-label" for="syncTelemetria">Temeletria</label>
        </div>
        <div class="table-responsive col-md-12 font-size-12 m-auto">
          <b-table responsive="sm" :items="tabelaAprimora" :fields="camposAprimora" per-page="7"
            :current-page="currentPageAprimora" @row-clicked="emitirRelatorioAprimora" tbody-tr-class="div-clickable"
            hover>
            <template v-slot:cell(dtconclusao)="data">
              {{ $tools.converteData(data.value) }}
            </template>
          </b-table>
          <div class="dataTables_paginate paging_simple_numbers float-end m-2">
            <ul class="pagination pagination-rounded mb-0 float-end">
              <b-pagination v-model="currentPageAprimora" :total-rows="rowsAprimora" per-page="7"></b-pagination>
            </ul>
          </div>
        </div>
      </b-card>
    </div>
    <div :class="tamanhoCardDespesa()" v-if="viewDespesas" data-v-step="30">
      <div class="card">
        <div class="card-body">
          <b-tabs pills content-class="p-3 text-muted">
            <b-tab active class="border-0">
              <template v-slot:title class="bg-secondary">
                <span class="d-sm-inline-block">Gráfico de Total por Despesa</span>
              </template>
              <b-table class="datatables" responsive="sm" :items="tabelaTotalDespesa" :fields="camposDespesa"
                per-page="7" striped>
                <template v-slot:cell(ds_icone_web)="data">
                  <div>
                    <span class="material-icons m-1 rounded-circle text-center badge"
                      :style="'background-color: ' + data.item.ds_cor_web" style="color: #fff; font-size: 18px">
                      <i :class="'mdi ' + data.item.ds_icone_web"></i>
                    </span>
                  </div>
                </template>
                <template #head(valor)="data">
                  <div class="me-2">
                    <span>{{ data.label }}</span>
                  </div>
                </template>
                <template v-slot:cell(porcentagem)="data">
                  <div class="d-flex">
                    <div class="col-md-8">
                      <b-progress :value="(data.item.total /
                                      parseFloat(somaTotalDespesas)) *
                                      100
                                      " :variant="corDaPorcentagem(
                                      (data.item.total /
                                        parseFloat(somaTotalDespesas)) *
                                      100
                                    )
                                      " height="10px"></b-progress>
                                                    </div>
                                                    <div class="col-md-4 text-center">
                                                      <h6>
                                                        {{
                                      (
                                        (data.item.total /
                                          parseFloat(somaTotalDespesas)) *
                                        100
                                      )
                                        .toFixed(2)
                                        .replace(".", ",")
                                    }}%
                      </h6>
                    </div>
                  </div>
                </template>
              </b-table>
            </b-tab>

            <b-tab class="border-0">
              <template v-slot:title>
                <span class="d-sm-inline-block">Gráfico de Total por Categoria</span>
              </template>
              <b-table class="datatables" responsive="sm" :items="tabelaTotalCategoria" :fields="camposCategoria"
                per-page="7" striped>
                <template v-slot:cell(icone)="data">
                  <div>
                    <span class="material-icons m-1 rounded-circle text-center badge"
                      :style="'background-color:' + data.item.cor" style="color: #fff; font-size: 18px">
                      <i :class="'mdi ' + data.item.icone"></i>
                    </span>
                  </div>
                </template>
                <template #head(valor)="data">
                  <div class="me-2">
                    <span>{{ data.label }}</span>
                  </div>
                </template>
                <template v-slot:cell(porcentagem)="data">
                  <div class="d-flex">
                    <div class="col-md-8">
                      <b-progress :value="(data.item.valor /
      parseFloat(tabelaTotalCategoria.soma)) *
      100
      " :variant="corDaPorcentagem(
      (data.item.valor /
        parseFloat(tabelaTotalCategoria.soma)) *
      100
    )
      " height="10px"></b-progress>
                    </div>
                    <div class="col-md-4 text-center">
                      <h6>
                        {{
      (
        (data.item.valor /
          parseFloat(tabelaTotalCategoria.soma)) *
                        100
                        )
                        .toFixed(2)
                        .replace(".", ",")
                        }}%
                      </h6>
                    </div>
                  </div>
                </template>
              </b-table>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      toolTipTable: {
        ex: false,
        fh: false,
        ma: false,
        ri: false,
      },
      viewTelemetria: false,
      listaVeiculo: [],
      veiculo: {},
      indexVeiculo: 0,
      google: {},
      map: {},
      dadosOcorrencia: {},
      telemetriaDiaria: [],
      camposTelemetria: [
        {
          key: "data",
          label: "Data",
        },
        {
          key: "excesso",
          label: "EV",
          class: "alinharCelulaDireita",
        },
        {
          key: "foraHorario",
          label: "FH",
          class: "alinharCelulaDireita",
        },
        {
          key: "madrugada",
          label: "MA",
          class: "alinharCelulaDireita",
        },
        {
          key: "risco",
          label: "CR",
          class: "alinharCelulaDireita",
        },
        {
          key: "informativo",
          label: "IN",
          class: "alinharCelulaDireita",
        },
      ],
      currentPageTelemetria: 1,
      rowsTelemetria: 0,
      directionsAux: [],
      markerOcorrencias: [],
      markerSede: 0,
      diaMapa: 0,
      kmDiario: 0,
      kmPercorrido: 0,
      kmInicial: 0,
      kmFinal: 0,
      //Dados Aprimora
      viewAprimora: false,
      syncTelemetria: false,
      disabledSyncTelemetria: true,
      tabelaAprimora: [],
      camposAprimora: [
        {
          key: "dtconclusao",
          label: "Data",
        },
        {
          key: "dsatividade",
          label: "Atividade",
        },
        {
          key: "nmfantasiaclienterural",
          label: "Cliente",
        },
        {
          key: "tipo",
          label: "Tipo",
        },
      ],
      currentPageAprimora: 1,
      rowsAprimora: 0,
      //Dados despesas
      viewDespesas: false,
      soma: 0,
      tabelaTotalDespesa: [],
      tabelaTotalCategoria: [],
      camposDespesa: [
        {
          key: "ds_icone_web",
          label: "",
        },
        {
          key: "ds_norma",
          label: "Despesa",
          sortable: true,
        },
        {
          key: "ds_categoria_norma",
          label: "Categoria",
          sortable: true,
        },
        {
          key: "total",
          label: "Valor",
          class: "alinharCelulaDireita fw-bold",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          sortable: true,
        },
        {
          key: "porcentagem",
          label: "Porcentagem de Gasto",
          sortable: true,
        },
      ],
      somaTotalDespesas: 0,
      camposCategoria: [
        {
          key: "icone",
          label: "",
        },
        {
          key: "nome",
          label: "Categoria",
          sortable: true,
        },
        {
          key: "valor",
          label: "Valor",
          class: "alinharCelulaDireita fw-bold",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          sortable: true,
        },
        {
          key: "porcentagem",
          label: "Porcentagem de Gasto",
          sortable: true,
        },
      ],
    };
  },
  created() {
    window.calcularKmWin = (el) => {
      this.calcularKm(el);
    };
  },

  methods: {
    tamanhoCardDespesa() {
      if (!this.viewTelemetria && !this.viewAprimora) {
        return "col-md-12";
      }
      if (this.viewTelemetria || this.viewAprimora) {
        return "col-md-12";
      }
      return "col-md-12";
    },
    async montarMapa() {
      try {
        this.google = await this.$gmaps();
        this.map = new this.google.maps.Map(document.getElementById("map"), {
          center: { lat: -23.469806037053726, lng: -51.81222191718324 },
          zoom: 8,
        });
      } catch (error) {
        console.error(error);
      }
    },
    filtrarTelemetria(itemDespesa, cabecalhoRdv) {
      return new Promise(() => {
        this.$http
          .post("api/telemetria", {
            referenciaInicio: itemDespesa.ge_rdv_iag.dt_inicio,
            referenciaFim: itemDespesa.ge_rdv_iag.dt_fim,
            cooperado: cabecalhoRdv.cd_pessoa,
            cd_projeto: cabecalhoRdv.cd_projeto,
          })
          .then((response) => {
            if (response.data.length > 0) {
              this.criarInformacoesDiaria(response.data);
              this.viewTelemetria = true;
              this.montarMapa();
            } else {
              //this.$tools.alerta("Nenhuma informação de telemetria encontrada", "error");
              this.viewTelemetria = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    criarInformacoesDiaria(paramTelemetria) {
      var dataGps = [];
      var index = 0;
      var indexDados = 0;
      this.kmInicial = paramTelemetria[0].nr_odometro;
      this.kmFinal = paramTelemetria[paramTelemetria.length - 1].nr_odometro;
      this.kmPercorrido = this.kmFinal - this.kmInicial;
      this.dadosOcorrencia = {
        excesso: 0,
        foraHorario: 0,
        madrugada: 0,
        risco: 0,
      };
      this.telemetriaDiaria = [];
      paramTelemetria.forEach((el) => {
        if (!dataGps.includes(el.data)) {
          index = dataGps.push(el.data);
          index--;

          this.telemetriaDiaria[index] = {
            data: el.data,
            dt_gps: new Date(el.dt_gps),
            dados: [],
            excesso: 0,
            foraHorario: 0,
            madrugada: 0,
            risco: 0,
            informativo: 0,
            mapaIndex: index,
            _cellVariants: {},
          };

          indexDados = this.telemetriaDiaria[index].dados.push(el);
          indexDados--;
          this.separarOcorrencias(el, index, indexDados);
        } else {
          indexDados = this.telemetriaDiaria[dataGps.length - 1].dados.push(el);
          indexDados--;
          this.separarOcorrencias(el, index, indexDados);
        }
      });
      this.rowsTelemetria = this.telemetriaDiaria.length;
      this.telemetriaDiaria.forEach((el) => {
        this.dadosOcorrencia.excesso += el.excesso;
        this.dadosOcorrencia.foraHorario += el.foraHorario;
        this.dadosOcorrencia.madrugada += el.madrugada;
        this.dadosOcorrencia.risco += el.risco;
      });
    },
    separarOcorrencias(param, index, indexDados) {
      switch (param.tp_posicao) {
        case "E":
          this.telemetriaDiaria[index].excesso++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "excesso.png";
          this.telemetriaDiaria[index]._cellVariants.excesso = "warning";
          break;
        case "F":
          this.telemetriaDiaria[index].foraHorario++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "foraHorario.png";
          this.telemetriaDiaria[index]._cellVariants.foraHorario = "secondary";
          break;
        case "M":
          this.telemetriaDiaria[index].madrugada++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "madrugada.png";
          this.telemetriaDiaria[index]._cellVariants.madrugada = "primary";
          break;
        case "R":
          this.telemetriaDiaria[index].risco++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "risco.png";
          this.telemetriaDiaria[index]._cellVariants.risco = "danger";
          break;
        default:
          this.telemetriaDiaria[index].informativo++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "informativo.png";
          break;
      }
    },
    montarMapaDirecoes(param) {
      this.limparMapa();
      this.diaMapa = param.data;
      this.kmDiario = 0;
      var arrayWayPoints = [];
      var matrizWayPoint = [];
      var i = 1;
      var localidades = [];
      var arrayLocation = [];

      param.dados.forEach((el) => {
        if (
          !localidades.includes(el.ds_localizacao) ||
          el.ds_localizacao == null
        ) {
          localidades.push(el.ds_localizacao);
          arrayLocation.push(el);
        }
      });

      arrayLocation.forEach((el) => {
        if (i % 24 == 0 || i == arrayLocation.length) {
          matrizWayPoint.push(arrayWayPoints);
          arrayWayPoints = [];
          arrayWayPoints.push({
            location: {
              lat: parseFloat(el.nr_latitude),
              lng: parseFloat(el.nr_longitude),
            },
          });
        } else {
          arrayWayPoints.push({
            location: {
              lat: parseFloat(el.nr_latitude),
              lng: parseFloat(el.nr_longitude),
            },
          });
        }
        i++;
      });

      matrizWayPoint.forEach((el) => {
        this.directionsAux.push(this.marcarDirecao(el));
      });

      this.adicionarMarcadores(param.dados);
    },
    marcarDirecao(param) {
      var originAux = param[0].location;
      var destinationAux = param[param.length - 1].location;
      var directionsService = new this.google.maps.DirectionsService();
      var directionsRenderer = new this.google.maps.DirectionsRenderer({
        preserveViewport: false,
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: "green",
          strokeOpacity: 0.5,
          strokeWeight: 7,
        },
      });
      directionsRenderer.setMap(this.map);

      var request = {
        origin: originAux,
        destination: destinationAux,
        waypoints: param,
        travelMode: "DRIVING",
      };

      directionsService.route(request, function (result, status) {
        if (status == "OK") {
          directionsRenderer.setDirections(result);
          window.calcularKmWin(result);
        }
      });

      return directionsRenderer;
    },
    calcularKm(param) {
      param.routes[0].legs.forEach((el) => {
        this.kmDiario += el.distance.value;
      });
    },
    adicionarMarcadores(param) {
      var icon = {};
      param.forEach((el, key) => {
        if (key === 0) {
          //Define icone de destino
          icon = {
            url: this.$iconOcorrencia + "origem.png",
            scaledSize: new this.google.maps.Size(30, 30),
          };
        } else if (key === param.length - 1) {
          //Define icone de origem
          icon = {
            url: this.$iconOcorrencia + "dest.png",
            scaledSize: new this.google.maps.Size(30, 30),
          };
        } else {
          icon = el.icon;
        }
        this.markerOcorrencias.push({
          marker: new this.google.maps.Marker({
            map: this.map,
            position: {
              lat: parseFloat(el.nr_latitude),
              lng: parseFloat(el.nr_longitude),
            },
            icon: icon,
          }),
          info: el,
        });
      });

      var popup = "";
      this.markerOcorrencias.forEach((el) => {
        popup =
          "Data: " +
          el.info.data +
          " " +
          el.info.hora +
          " " +
          this.$tools.diaSemanaAbrev(new Date(el.info.dt_gps).getDay()); //Hora
        popup += el.info.nr_placa ? "<br>Placa: " + el.info.nr_placa : ""; //Placa
        popup += el.info.veiculo ? "<br>Veiculo: " + el.info.veiculo : ""; //Veiculo
        popup += el.info.rastreador
          ? "<br>Rastreador: " + el.info.rastreador
          : ""; //Rastreador
        popup += "<br>Ocorrência: " + this.siglaOcorrencia(el.info.tp_posicao); //Ocorrência
        popup += el.info.nr_velocidade
          ? "<br>Velocidade: " + el.info.nr_velocidade + " Km/H"
          : ""; //Velocidade
        popup += el.info.ds_localizacao
          ? "<br>Localidade: " + el.info.ds_localizacao
          : ""; //Descricao
        popup +=
          "<br>Cidade-UF: " +
          el.info.ge_regiao.nm_regiao +
          " - " +
          el.info.ge_regiao.ds_uf; //Regiao

        var infowindow = new this.google.maps.InfoWindow({
          content: popup,
        });
        el.marker.addListener("click", () => {
          infowindow.open({
            anchor: el.marker,
            map: this.map,
            shouldFocus: false,
          });
        });
      });
    },
    marcarSede() {
      if (this.markerSede) {
        this.markerSede.setMap(null);
      }
      this.markerSede = new this.google.maps.Marker({
        map: this.map,
        position: {
          lat: parseFloat(this.despesas[0].nr_latitude_sede),
          lng: parseFloat(this.despesas[0].nr_longitude_sede),
        },
        icon: {
          url: this.$iconOcorrencia + "sede.png",
          scaledSize: new this.google.maps.Size(30, 30),
        },
      });
      this.map.setCenter({
        lat: parseFloat(this.despesas[0].nr_latitude_sede),
        lng: parseFloat(this.despesas[0].nr_longitude_sede),
      });

      var infowindow = new this.google.maps.InfoWindow({
        content: "Cidade Sede: " + this.dadosInfoCoop.sede,
      });
      this.markerSede.addListener("click", () => {
        infowindow.open({
          anchor: this.markerSede,
          map: this.map,
          shouldFocus: false,
        });
      });
    },
    limparMapa() {
      if (this.directionsAux) {
        this.directionsAux.forEach((el) => {
          el.setMap(null);
        });
        this.markerOcorrencias.forEach((el) => {
          el.marker.setMap(null);
        });
        this.directionsAux = [];
        this.markerOcorrencias = [];
      }
    },
    siglaOcorrencia(sigla) {
      switch (sigla) {
        case "E":
          return "Excesso de velocidade";
        case "F":
          return "Uso fora de horário";
        case "M":
          return "Uso na madrugada";
        case "R":
          return "Condução de Risco";
        default:
          return "Informativo";
      }
    },
    //Metodos Aprimora
    filtrarAprimora(itemDespesa) {
      this.$http
        .post("api/aprimora", {
          referenciaInicio: itemDespesa.ge_rdv_iag.dt_inicio,
          referenciaFim: itemDespesa.ge_rdv_iag.dt_fim,
          cooperado: itemDespesa.cd_cooperado,
          cd_projeto: itemDespesa.cd_projeto,
          sq_contrato: itemDespesa.sq_contrato,
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.tabelaAprimora = response.data;
            this.viewAprimora = true;
            this.rowsAprimora = this.tabelaAprimora.length;
          } else {
            this.viewAprimora = false;
            this.rowsAprimora = 0;
          }
        })
        .catch(() => {
          //this.$tools.alerta("Erro ao buscar informaçoes do aprimora", "error");
          this.viewAprimora = false;
          this.rowsAprimora = 0;
        });
    },
    sincronizaAprimoraTelemetria() {
      if (this.syncTelemetria) {
        this.tabelaAprimora = this.tabelaAprimoraAux.filter((el) => {
          if (this.$tools.converteData(el.dtconclusao) !== this.diaMapa) {
            return false;
          }
          return true;
        });
      } else {
        this.tabelaAprimora = this.tabelaAprimoraAux;
      }
      this.rowsAprimora = this.tabelaAprimora.length;
    },
    emitirRelatorioAprimora(dadosAprimora) {
      var atividade = {
        Aplicação: "Aplicacao",
        Avaliação: "Avaliacao",
        Colheita: "Colheita",
        Evento: "Evento",
        "Geração de Demanda": "GeracaodeDemanda",
        Plantio: "Plantio",
        Visita: "Visita",
      };
      var url = "https://uniweb2.unicampo.coop.br/Relatorios/Relatorio/";
      url += atividade[dadosAprimora.tipo]
        ? atividade[dadosAprimora.tipo]
        : "Visita";
      url += "/" + dadosAprimora.cdpessoa;
      url += "/" + dadosAprimora.sqformulario;
      url += "/" + dadosAprimora.sys_usuario.sq_usuario;
      url += "/" + (Math.floor(Math.random() * 1000) + 1000);
      window.open(url);
    },
    montandoGraficoDespesa(dados, tour = false) {
      if (dados == "Tirar dados fakes") {
        this.viewDespesas = false;
        this.tabelaTotalDespesa = [];
        return;
      }
      if (tour == true) {
        this.tabelaTotalDespesa = dados;
        return;
      }
      this.viewDespesas = true;
      this.somaTotalDespesas = 0;
      this.$http
        .get("api/rdvCooperado/buscarGraficoDespesas/" + dados)
        .then((response) => {
          this.tabelaTotalDespesa = response.data
          this.tabelaTotalDespesa.forEach(el => {
            this.somaTotalDespesas += parseFloat(el.total)
          });
        });
    },
    montandoGraficoCategoria(cdRdv) {
      var somatoria = 0;
      this.$http
        .get("api/rdvCooperado/buscarDespesasCategoria/" + cdRdv)
        .then((response) => {
          this.tabelaTotalCategoria = [];
          response.data.forEach((el) => {
            this.tabelaTotalCategoria.push({
              nome: el.ds_categoria_norma,
              valor: parseFloat(el.total),
              icone: el.ds_icone_web,
              cor: el.ds_cor_web,
            });
            somatoria += parseFloat(el.total);
          });
          this.tabelaTotalCategoria.soma = somatoria;
          this.tabelaTotalCategoria = this.tabelaTotalCategoria.sort((a, b) => {
            if (a.valor < b.valor) {
              return 1;
            } else {
              return -1;
            }
          });
        });
    },
    inputDadosFakeTour(dados) {
      if (dados == "Tirar dados fakes") {
        this.viewDespesas = false;
        this.tabelaTotalDespesa = [];
        return;
      }
      this.viewDespesas = true;
      this.tabelaTotalDespesa = [dados];
    },
    corDaPorcentagem(valor) {
      if (100 - parseInt(valor) <= 70) {
        return "danger";
      }
      if (100 - parseInt(valor) <= 90) {
        return "warning";
      }
      return "primary";
    },
    limparPesquisa() {
      this.viewTelemetria = false;
      this.viewAprimora = false;
      this.viewDespesas = false;
    },
  },
};
</script>